import { Box, HStack, ModalCloseButton } from '@chakra-ui/react';
import type { SearchBarProps } from '@time-line/components/common';
import { SearchBar } from '@time-line/components/common';
import { Close } from '@time-line/components/icons';

interface SearchHeaderProps {
  inputProps: SearchBarProps['inputProps'];
  isBorderVisible: boolean;
}

export function SearchHeader({
  inputProps,
  isBorderVisible,
}: SearchHeaderProps) {
  return (
    <Box pos="relative" h="80px">
      <Box
        pos="absolute"
        top="0"
        left="0"
        bg="gray.50"
        width="100%"
        zIndex="99999"
        borderRadius="2xl"
        px="sm"
      >
        <HStack
          gap="3xs"
          h="80px"
          borderBottom={isBorderVisible ? '1px solid' : 'none'}
          borderColor="blackAlpha.250"
        >
          <SearchBar
            size="lg"
            variant="unstyled"
            displayClearAsText
            inputProps={{
              ...inputProps,
              _focusVisible: { boxShadow: 'outline' },
            }}
          />
          <ModalCloseButton justifySelf="end">
            <Close boxSize="sm" />
          </ModalCloseButton>
        </HStack>
      </Box>
    </Box>
  );
}
